import React from "react";
import ContentLoader from "react-content-loader";

const ColumnOneSpan = {
  fontWeight: "500",
};
const ColumnTwo = {
  float: "right",
};

const InfoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
      fill="#5A858E"
    />
  </svg>
);

export default function SidebarAddressSummary(props) {

  const [userClassDesc, setUserClassDesc] = React.useState("");
  const [promoCode, setPromoCode] = React.useState("");
  const [planType, setPlanType] = React.useState("");
  
  const PlanSummaryLoader = () => (
    <ContentLoader style={{ width: "100%" }}>
      <rect x="10" y="0" rx="3" ry="3" width="250" height="10" />
      <rect x="10" y="30" rx="3" ry="3" width="250" height="10" />
      <rect x="10" y="60" rx="3" ry="3" width="250" height="10" />
    </ContentLoader>
  );

  const handleEdit = (editStep) => {
    if (editStep === 1) {
      window.location.href = "/";
    } else {
      props.editFunction(editStep);
    }
  };

  const formatAddress = (addr) => {
    addr = addr.replace(/,/g, ", ");
    return addr.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  };

  React.useEffect(() => {
  
    if (props.values.userClass instanceof Array) {
      props.values.userClass.map(function (item) {
        if (item.UserClassCode === props.values.userClassCode) {
          setUserClassDesc(item.UserClassDescription);
        }
      });
    }

    if (props.values.promoCode) {
      setPromoCode(props.values.promoCode);
    }

    if (props.values.planType) {
      setPlanType(props.values.planType);
    }

  });

  return (
    <>
      <div
        className="col-12 d-md-block d-lg-block"
        id="sideBarPlanSummary"
      >
        {props.isLoading ? (
          <PlanSummaryLoader />
        ) : (
          <div className="row">
            <div className="col-12" style={{ marginBottom: "2rem" }}>
              {props.values.firstName ? (
                <h4 className="h4 primary">
                  Plan Summary for {props.values.firstName}
                </h4>
              ) : (
                <h4 className="h4 primary">Plan Summary</h4>
              )}
            </div>
            <div className="col-9">
              <h5 className="h5 primary">Address</h5>
            </div>
            {props.values.canEdit && (
              <div className="col-3 text-right" style={ColumnTwo}>
                <span
                  href="#"
                  style={{ cursor: "pointer" }}
                  id="editButton"
                  onClick={(e) => handleEdit(1)}
                >
                  Edit
                </span>
              </div>
            )}
            <div className="col-12">
              <span className="summary-address" style={ColumnOneSpan}>
                {formatAddress(props.values.address)}
              </span>
            </div>
            <div className="col-12" style={{ marginTop: "2rem" }}>
              <table id="addressDetails">
                <tbody>
                  <tr style={{ fontSize: "1.5rem" }}>
                    <td>
                      <span>
                        <strong>ICP</strong>
                      </span>
                    </td>
                    <td className="text-right">{props.values.icp}</td>
                  </tr>
                  {props.values.isAdditionalProperty !== 'yes' && userClassDesc !== "" && (
                    <tr style={{ fontSize: "1.5rem" }}>
                      <td>
                        <span>
                          <strong>User Type</strong>
                        </span>
                      </td>
                      <td className="text-right">{userClassDesc}</td>
                    </tr>
                  )}
                  {promoCode !== "" && (
                    <tr style={{ fontSize: "1.5rem" }}>
                      <td>
                        <span>
                          <strong>Promo Code:</strong>
                        </span>
                      </td>
                      <td className="text-right">{promoCode}</td>
                    </tr>
                  )}
                  {planType !== "" && (
                    <tr style={{ fontSize: "1.5rem" }}>
                      <td>
                        <span>
                          <strong>Plan Type:</strong>
                        </span>
                      </td>
                      <td className="text-right">{planType}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {props.title === "Find My Price" && (
        <div
          className="col-12 d-none d-sm-none d-md-block d-lg-block"
          id="notificationBox"
        >
          {props.isLoading ? (
            <PlanSummaryLoader />
          ) : (
            <div>
              <InfoIcon />
              {/* <p><strong>What you'll need to complete:<br/> Proof of identity</strong></p>
              <p>Have your NZ Driver's license or Passport ready.</p>
              <p>Have your Grey Power member ID number ready.</p>
              <p><strong>Important dates</strong></p>
              <p>If you’re relocating, provide your moving dates.</p> */}
              <div dangerouslySetInnerHTML={{ __html: props.forms.FindMyPriceSidebarNote }} />
            </div>
          )}
        </div>
      )}
      {(props.title === "Choose Your Plan") && (
        <div
          className="col-12 d-none d-sm-none d-md-block d-lg-block"
          id="notificationBox"
        >
          {props.isLoading ? (
            <PlanSummaryLoader />
          ) : (
            <div>
              <InfoIcon />
              {/* {props.noGst ? (
                <>
                  <p>Prices are shown in cents and are based on the information you have provided.</p>
                  <p>&nbsp;</p>
                  <a href="https://www.greypowerelectricity.co.nz/offers-and-promotion-terms-and-conditions/" target="_blank" rel="noopener">
                    *Sign up promotional offer terms apply
                  </a>
                  <p>&nbsp;</p>
                  <p>** It is not practical to flow through the per kWh Network charges for all networks. For some networks, Network Services charges will be calculated using published prices and other assumptions that allow us to recover network charges across our customer base on your network.</p>
                </>
              ): (
                <>
                  <p>Please note all prices quoted exclude GST.</p>
                  <p>&nbsp;</p>
                  <p>Prices are shown in cents and are based on the information you have provided. </p>
                  <p>&nbsp;</p>
                  <p>
                    <a href="https://www.greypowerelectricity.co.nz/offers-and-promotion-terms-and-conditions/" target="_blank" rel="noopener">
                      *Sign up promotional offer terms apply
                    </a>
                  </p>
                  <p>&nbsp;</p>
                  <p>** It is not practical to flow through the per kWh Network charges for all networks. For some networks, Network Services charges will be calculated using published prices and other assumptions that allow us to recover network charges across our customer base on your network.</p>
                </>
              )} */}
              {props.noGst ? <div dangerouslySetInnerHTML={{ __html: props.forms.ChooseYourPlanSidebarNoteNoGST }} /> : <div dangerouslySetInnerHTML={{ __html: props.forms.ChooseYourPlanSidebarNote }} />}
            </div>
          )}
        </div>
      )}
      {(props.title === "Build Your Plan") && (
        <div
          className="col-12 d-none d-sm-none d-md-block d-lg-block"
          id="notificationBox"
        >
          {props.isLoading ? (
            <PlanSummaryLoader />
          ) : (
            <div>
              <InfoIcon />
              {props.noGst ? (
                <>
                  {/* <p>All broadband and home prices quoted include GST. If you cancel your power account, your broadband account will be cancelled. Termination fees may apply.</p>
                  <p>&nbsp;</p>
                  <p>We will send you a Welcome Pack when your electricity is connected this will include a detailed breakdown of the Fixed and Variable charges.The above pricing is based on our assumption of your meter configuration, data provision and standard Network Charges. If for any reason your actual configuration, data provision or Network Services charges are different, our pricing for your meter configuration, data provision and Network services charges will apply.</p> */}
                  <div dangerouslySetInnerHTML={{ __html: props.forms.BuildYourPlanSidebarNoteNoGST }} />
                </>
              ): (
                <>
                {/* <p>Please note all electricity and gas prices quoted exclude GST.</p>
                <p>All broadband and home prices quoted include GST.  If you cancel your power account, your broadband account will be cancelled. Termination fees may apply.</p>
                <p>&nbsp;</p>
                <p>We will send you a Welcome Pack when your electricity is connected this will include a detailed breakdown of the Fixed and Variable charges.The above pricing is based on our assumption of your meter configuration, data provision and standard Network Charges. If for any reason your actual configuration, data provision or Network Services charges are different, our pricing for your meter configuration, data provision and Network services charges will apply.</p> */}
                 <div dangerouslySetInnerHTML={{ __html: props.forms.BuildYourPlanSidebarNote }} />
                </>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}